exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".row-bg[data-v-fe14beae]{flex-wrap:wrap;gap:0 6%}\n", ""]);

// exports
